import React, { useState,useEffect } from 'react'
import './GradesStyle.css'
// import Dropdown from '../../components/globalComponents/dropdown/Dropdown'
// import ProgressBar from '../../components/globalComponents/progressBar/ProgressBar'
// import FileViewer from '../../components/globalComponents/fileViewer/FileViewer'
// import Button from '../../components/globalComponents/buttons/primaryButton/PrimaryButton'
import QuizPopup from '../../components/popups/quizPopup/QuizPopup'
// import PrimaryButton from '../../components/globalComponents/buttons/primaryButton/PrimaryButton'
import {useDispatch, useSelector} from 'react-redux'
import {getAllStudentCoursesByTerm,getSpecificStudentAssignmentGradesAdmin,gradeSliceFunction,clearState} from '../../reducers/gradeSlice'
import PageLoader from '../../components/globalComponents/PageLoader/PageLoader'
const Grades = () => {
    const dispatch = useDispatch()

     const {courseData,gradeData,isFetching,studentName,isDone}=useSelector(gradeSliceFunction)
     const [toggleCourse, setToggleCourse] = useState(0)

     useEffect(()=>{
        dispatch(getAllStudentCoursesByTerm())
        // eslint-disable-next-line
     },[])

     useEffect(()=>{

        if(courseData?.length > 0 && isDone ){
            console.log(courseData?.length);
            dispatch(getSpecificStudentAssignmentGradesAdmin(courseData[0].courseId))
            dispatch(clearState());
        }
        // eslint-disable-next-line
     },[courseData])

     const handleClick =(id)=>{
        dispatch(getSpecificStudentAssignmentGradesAdmin(id))
        console.log("inside handleClick",id) 
     }




    console.log(gradeData,"gradeData");


    return (
        <>
        { isFetching && <PageLoader/>}
            <div className="pageHeader">
                <p className="componentHeading"></p>
                <div className="pageTogglers">
                    <div className="pageToggler active">

                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.875 3.33341C1.875 2.06776 2.90101 1.04175 4.16667 1.04175H15.8333C17.099 1.04175 18.125 2.06776 18.125 3.33341V15.0001C18.125 16.2657 17.099 17.2917 15.8333 17.2917H14.7467L13.1026 18.9358C12.8585 19.1799 12.4628 19.1799 12.2188 18.9358L10.0089 16.7261L7.79917 18.9358C7.55509 19.1799 7.15936 19.1799 6.91528 18.9358L5.27121 17.2917H4.16667C2.90101 17.2917 1.875 16.2657 1.875 15.0001V3.33341ZM5.88409 16.1369L7.35723 17.61L8.76314 16.2041C8.10573 15.9205 7.56508 15.4176 7.23328 14.7877L5.88409 16.1369ZM6.87531 13.3779L4.55826 15.6949C4.46371 15.7895 4.40258 15.9112 4.38248 16.0417H4.16667C3.59137 16.0417 3.125 15.5754 3.125 15.0001V3.33341C3.125 2.75812 3.59137 2.29175 4.16667 2.29175H15.8333C16.4086 2.29175 16.875 2.75812 16.875 3.33341V15.0001C16.875 15.5754 16.4086 16.0417 15.8333 16.0417H15.6354C15.6153 15.9112 15.5542 15.7895 15.4596 15.6949L13.1249 13.3602C13.125 13.3513 13.125 13.3423 13.125 13.3334C13.125 11.6075 11.7259 10.2084 10 10.2084C8.27411 10.2084 6.875 11.6075 6.875 13.3334C6.875 13.3483 6.8751 13.3631 6.87531 13.3779ZM8.13774 13.5532C8.13745 13.5505 8.13714 13.5478 8.13682 13.5451C8.12901 13.4756 8.125 13.405 8.125 13.3334C8.125 12.2979 8.96447 11.4584 10 11.4584C11.0355 11.4584 11.875 12.2979 11.875 13.3334C11.875 14.361 11.0483 15.1956 10.0237 15.2083C10.0198 15.2082 10.0158 15.2082 10.0118 15.2083L9.99711 15.2084C9.03722 15.207 8.24643 14.4842 8.13774 13.5532ZM11.2492 16.1987C11.9051 15.9124 12.4437 15.4074 12.7729 14.7759L14.1338 16.1369L12.6607 17.61L11.2492 16.1987ZM6.875 5.00008C6.875 4.6549 7.15482 4.37508 7.5 4.37508H12.5C12.8452 4.37508 13.125 4.6549 13.125 5.00008C13.125 5.34526 12.8452 5.62508 12.5 5.62508H7.5C7.15482 5.62508 6.875 5.34526 6.875 5.00008ZM5.20833 7.91675C5.20833 7.57157 5.48816 7.29175 5.83333 7.29175H14.1667C14.5118 7.29175 14.7917 7.57157 14.7917 7.91675C14.7917 8.26193 14.5118 8.54175 14.1667 8.54175H5.83333C5.48816 8.54175 5.20833 8.26193 5.20833 7.91675Z" fill="#262626" />
                        </svg>

                        Grades
                    </div>
                </div>
                <div></div>
            </div>
            <div className="courseDetailsOuter gradesOuter">
                <QuizPopup />
                <div className="courseDetailsMenuOuter">
                    <h4 className="courseDetailsMenuHeading">Courses ({courseData.length})</h4>
                    { courseData?.map((num , index)=>(
                      <div onClick={() => {handleClick(num.courseId);setToggleCourse(index)}} className={`sessionOverviewCard ${toggleCourse === index ? "active" : ""}`} key ={index} >
                      <p className="courseNumber">course {index+1}</p>
                      <div className="sessionCardHeader">
                          <p className="sessionHeading">{num.CourseRoster.courseName}</p>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2248 4.55806C11.4688 4.31398 11.8646 4.31398 12.1086 4.55806L17.1086 9.55806C17.3527 9.80214 17.3527 10.1979 17.1086 10.4419L12.1086 15.4419C11.8646 15.686 11.4688 15.686 11.2248 15.4419C10.9807 15.1979 10.9807 14.8021 11.2248 14.5581L15.1578 10.625H3.33337C2.9882 10.625 2.70837 10.3452 2.70837 10C2.70837 9.65482 2.9882 9.375 3.33337 9.375H15.1578L11.2248 5.44194C10.9807 5.19786 10.9807 4.80214 11.2248 4.55806Z" fill="#171717" />
                          </svg>

                      </div>
                  </div>
                    ))}
                   
                    {/* <div className="sessionOverviewCard">
                        <p className="courseNumber">course 1</p>
                        <div className="sessionCardHeader">
                            <p className="sessionHeading">Identify your business goals.</p>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2248 4.55806C11.4688 4.31398 11.8646 4.31398 12.1086 4.55806L17.1086 9.55806C17.3527 9.80214 17.3527 10.1979 17.1086 10.4419L12.1086 15.4419C11.8646 15.686 11.4688 15.686 11.2248 15.4419C10.9807 15.1979 10.9807 14.8021 11.2248 14.5581L15.1578 10.625H3.33337C2.9882 10.625 2.70837 10.3452 2.70837 10C2.70837 9.65482 2.9882 9.375 3.33337 9.375H15.1578L11.2248 5.44194C10.9807 5.19786 10.9807 4.80214 11.2248 4.55806Z" fill="#171717" />
                            </svg>

                        </div>
                    </div> */}
                </div>
                <div className="courseContentOuter">

                    {/* <p className="courseHeading">Applied Finance</p> */}
                    <div className="studentProfileGradeBox">
                        <div className="studentProfileGradeBoxLeft">
                            <img src="https://events.powerathletehq.com/wp-content/uploads/2018/06/grey-person-coming-soon-e1529779699986.jpg" className="profileImg" alt='' />
                            <div className="contentLeft">
                                <p className="name">{studentName?.firstName}</p>
                                <div className="progesssCotent">
                                    {/* <p className="progressText">Program Progress</p> */}
                                    <p className="progressText">Total Marks: {gradeData.length>0 && gradeData[0]?.totalMarks}</p>

                                    {/* <p className="progressNumber">72%</p> */}
                                </div>
                                {/* <ProgressBar color={'var(--success-4)'} width={'72%'} /> */}
                            </div>

                        </div>
                        <div className="studentProfileGradeBoxRight">
                            {/* <p className="heading">overall cgp</p> */}
                            <p className="heading">Grade</p>
                            {
                                (gradeData?.length && gradeData[0]?.grades !== null) > 0 ? 
                                <p className="cgp">{gradeData[0]?.grades}</p>
                                :
                                <p className="dangerText">Pending</p>
                            }
                        </div>
                    </div>
                    {/* <div className="courseTagBox">
                        <div className="courseTagInner">
                            <p className="courseNumber">course </p>
                            <p className="courseName">Fundamentals of Accounting</p>
                        </div>
                        <div className="courseTagInner">
                            <p className="courseNumber">Course CGP</p>
                            <p className="courseName">56/100</p>
                        </div>
                    </div> */}
                    <div className="courseMarksOuter">
                        <div className="courseMarksHeader">
                            <div className="courseMarksHeaderElement" style={{ width: '35%' }}>
                                <p className="heading">all assignment/quiz</p>
                                {/* <p className="text">General</p> */}
                            </div>
                            {/* <div className="courseMarksHeaderElement" style={{ width: '17%' }}>
                                <p className="heading">percentage</p>
                                <p className="text successText">70%</p>
                            </div>
                            <div className="courseMarksHeaderElement" style={{ width: '30%' }}>
                                <p className="heading">marks</p>
                                <p className="text successText">70/100</p>
                            </div> */}
                            {/* <div className="courseMarksHeaderElement">
                                <div class="toggleBtn"><img src="../assets/icons/chevron-down-black.svg" alt="" class="toggleBtnIcon" /></div>
                            </div> */}
                        </div>
                        <table className="courseMarksTable active" cellSpacing={0} cellPadding={0}>
                                 <tbody>
                             {gradeData?.length > 0 ? gradeData?.map((num , index)=>(
                                 <tr key={index}>
                                     <td>{num?.Assignment?.name}</td>
                                     <td></td>
                                     {
                                        num.obtainedMarks === null ? <td><p className="dangerText">Pending</p></td>
                                        :
                                        <td><p className="successText">{num.obtainedMarks}/{num?.Assignment?.totalPoint}</p></td>
                                     }
                                     {/* <td><PrimaryButton classname={'secondaryBtn'} children={'View'} /></td> */}
                                 </tr>
                             )):
                             <tr>No Assignment Added</tr>
                             } 
                             </tbody>
                           
                        </table>
                    </div>
                    {/* <div className="courseMarksOuter">
                        <div className="courseMarksHeader">
                            <div className="courseMarksHeaderElement" style={{ width: '30%' }}>
                                <p className="heading">all assignment/quiz</p>
                                <p className="text">General</p>
                            </div>
                            <div className="courseMarksHeaderElement" style={{ width: '17%' }}>
                                <p className="heading">percentage</p>
                                <p className="text successText">70%</p>
                            </div>
                            <div className="courseMarksHeaderElement" style={{ width: '30%' }}>
                                <p className="heading">marks</p>
                                <p className="text successText">70/100</p>
                            </div>
                            <div className="courseMarksHeaderElement">
                                <div class="toggleBtn"><img src="../assets/icons/chevron-down-black.svg" alt="" class="toggleBtnIcon" /></div>
                            </div>
                        </div>
                        <table className="courseMarksTable " cellSpacing={0} cellPadding={0}>
                            <tbody>
                                <tr>
                                    <td>Fundamentals of Marketing</td>
                                    <td></td>
                                    <td><p className="successText">91/100</p></td>
                                    <td><PrimaryButton classname={'secondaryBtn'} children={'View'} /></td>
                                </tr>
                                <tr>
                                    <td>Fundamentals of Marketing</td>
                                    <td></td>
                                    <td><p className="successText">91/100</p></td>
                                    <td><PrimaryButton classname={'secondaryBtn'} children={'View'} /></td>
                                </tr>
                                <tr>
                                    <td>Fundamentals of Marketing</td>
                                    <td></td>
                                    <td><p className="successText">91/100</p></td>
                                    <td><PrimaryButton classname={'secondaryBtn'} children={'View'} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="courseMarksOuter">
                        <div className="courseMarksHeader">
                            <div className="courseMarksHeaderElement" style={{ width: '35%' }}>
                                <p className="heading">all assignment/quiz</p>
                                <p className="text">General</p>
                            </div>
                            <div className="courseMarksHeaderElement" style={{ width: '17%' }}>
                                <p className="heading">percentage</p>
                                <p className="text successText">70%</p>
                            </div>
                            <div className="courseMarksHeaderElement" style={{ width: '30%' }}>
                                <p className="heading">marks</p>
                                <p className="text successText">70/100</p>
                            </div>
                            <div className="courseMarksHeaderElement">
                                <div class="toggleBtn"><img src="../assets/icons/chevron-down-black.svg" alt="" class="toggleBtnIcon" /></div>
                            </div>
                        </div>
                        <table className="courseMarksTable " cellSpacing={0} cellPadding={0}>
                            <tbody>
                                <tr>
                                    <td>Fundamentals of Marketing</td>
                                    <td></td>
                                    <td><p className="successText">91/100</p></td>
                                    <td><PrimaryButton classname={'secondaryBtn'} children={'View'} /></td>
                                </tr>
                                <tr>
                                    <td>Fundamentals of Marketing</td>
                                    <td></td>
                                    <td><p className="successText">91/100</p></td>
                                    <td><PrimaryButton classname={'secondaryBtn'} children={'View'} /></td>
                                </tr>
                                <tr>
                                    <td>Fundamentals of Marketing</td>
                                    <td></td>
                                    <td><p className="successText">91/100</p></td>
                                    <td><PrimaryButton classname={'secondaryBtn'} children={'View'} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default Grades